export default __webpack_public_path__ + "static/media/IMG_1256.6ba70df7.jpg";